export const recurringPeriodsEn = [
  {label: 'Daily', value: 1},
  {label: 'Weekly', value: 2},
  {label: 'Monthly', value: 3},
  {label: 'Yearly', value: 4},
];

export const recurringPeriodsHe = [
  {label: 'יומי', value: 1},
  {label: 'שבועי', value: 2},
  {label: 'חודשי', value: 3},
  {label: 'שנתי', value: 4},
];